import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";

import CategoriesList from "@/modules/news/admin/components/NewsCategoriesList";
import { fetchCategoriesQueryOptions } from "@/modules/news/admin/services";

export const Route = createFileRoute("/admin/_panel/_news/news/categories/")({
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(fetchCategoriesQueryOptions()),
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("news.admin");

  return (
    <Container
      title={t("Categories", {
        ns: "core.shared",
      })}
      description={t("Manage, Create, Edit Categories")}
    >
      <CategoriesList />
    </Container>
  );
}
